var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0925 8.2412V5.92009C15.0925 3.20331 12.8169 1.00005 10.0109 1.00005C7.20491 0.988156 4.92037 3.18061 4.90809 5.89847V8.2412M10.0002 13.3817V15.7828M14.2659 21H5.73409C3.39596 21 1.5 19.1654 1.5 16.9005V12.2637C1.5 9.99882 3.39596 8.16421 5.73409 8.16421H14.2659C16.604 8.16421 18.5 9.99882 18.5 12.2637V16.9005C18.5 19.1654 16.604 21 14.2659 21Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5daf376b.svg";
export { ForwardRef as ReactComponent };